---
en:
  activerecord:
    models:
      comment:
        one: Comment
        other: Comments
  comments:
    add_comment: Add a comment
    notify_replies: Notify me of new replies
